import React, { useEffect, useState } from "react";
import { useAuth } from "@/auth";
import { useI18n } from "@/i18n";
import { Save } from "lucide-react";
import { toast } from "sonner";

export default function Volumen() {
  const { api } = useAuth();
  const { t } = useI18n();
  const [aereo, setAereo] = useState(6000);
  const [maritimo, setMaritimo] = useState(1000);

  useEffect(() => {
    api.get("/config").then(r => { setAereo(r.data.vol.aereo); setMaritimo(r.data.vol.maritimo); });
  }, []);

  const save = async () => {
    await api.put("/config/vol", { aereo: +aereo, maritimo: +maritimo });
    toast.success(t("saved"));
  };

  return (
    <div className="max-w-lg space-y-4" data-testid="volumen-page">
      <div>
        <h2 className="font-display text-lg font-semibold">{t("volumetric_rules")}</h2>
        <p className="text-sm text-slate-500">{t("formula_air")}</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-5">
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1">{t("air_divisor_full")}</label>
          <input data-testid="vol-aereo" type="number" min="1000" value={aereo} onChange={(e)=>setAereo(+e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-lg" />
          <p className="text-xs text-slate-500 mt-1">{t("formula_air")}</p>
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1">{t("sea_divisor_full")}</label>
          <input data-testid="vol-maritimo" type="number" min="500" value={maritimo} onChange={(e)=>setMaritimo(+e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-lg" />
          <p className="text-xs text-slate-500 mt-1">{t("formula_sea")}</p>
        </div>
        <button data-testid="vol-save" onClick={save} className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-4 py-2 rounded-lg flex items-center gap-2 transition-colors">
          <Save className="w-4 h-4" /> {t("save")}
        </button>
      </div>
    </div>
  );
}
